import { useTranslations } from 'next-intl';
import { CatTooltip, CatTextPassage } from 'components/blocks-components';
import { TooltipPosition } from '@blocks-web-components/components/tooltip/tooltip.model';
import styles from './product-core-desposit.module.scss';
import cx from 'classnames';

interface ProductCoreDepositTooltipProps {
  tooltipPosition?: TooltipPosition;
  isMobileTooltipDrawer?: boolean;
  children: React.ReactNode;
}

const ProductCoreDepositTooltip = ({
  tooltipPosition = 'top',
  isMobileTooltipDrawer = false,
  children
}: ProductCoreDepositTooltipProps) => {
  const t = useTranslations();

  return (
    <CatTooltip
      isInteractive
      position={tooltipPosition}
      className={cx(styles['product-core-deposit__tooltip'], {
        ['d-none d-md-block']: isMobileTooltipDrawer
      })}
    >
      {children}
      <CatTextPassage size="xs">
        <div
          className={cx(
            'd-flex flex-column',
            styles['product-core-deposit__tooltip-content']
          )}
        >
          <b>{t('CAT_CORE_DEPOSIT_TITLE')}</b>
          {t('CAT_CORE_UNIT_SELL')}
        </div>
      </CatTextPassage>
    </CatTooltip>
  );
};

export default ProductCoreDepositTooltip;
